import { ref, onMounted, onUnmounted, watch } from "vue";
import { router } from "@inertiajs/vue3";

export function useAnchorListener(containerRef) {
    const activeListeners = new WeakMap<Element, EventListener>();

    const attachAnchorListeners = () => {
        const container = containerRef.value;
        if (container) {
            const anchorTags = container.querySelectorAll("a");

            anchorTags.forEach(anchor => {
                if (activeListeners.has(anchor)) {
                    const oldListener = activeListeners.get(anchor);
                    anchor.removeEventListener("click", oldListener!);
                }

                const clickListener = (event: Event) => {
                    event.preventDefault();
                    const href = (event.currentTarget as HTMLAnchorElement).href;

                    const isInternalLink = href.startsWith(window.location.origin);

                    if (!isInternalLink) {
                        window.open(href, "_blank");
                    } else {
                        try {
                            router.visit(href);
                        } catch (err) {
                            console.error("Router navigation failed", err);
                            window.location.href = href;
                        }
                    }
                };

                anchor.addEventListener("click", clickListener);
                activeListeners.set(anchor, clickListener);
            });
        }
    };

    const removeAnchorListeners = () => {
        const container = containerRef.value;
        if (container) {
            const anchorTags = container.querySelectorAll("a");
            anchorTags.forEach(anchor => {
                if (activeListeners.has(anchor)) {
                    const oldListener = activeListeners.get(anchor);
                    anchor.removeEventListener("click", oldListener!);
                    activeListeners.delete(anchor);
                }
            });
        }
    };

    onMounted(() => {
        attachAnchorListeners();
    });

    onUnmounted(() => {
        removeAnchorListeners();
    });
    
    return {
        attachAnchorListeners,
        removeAnchorListeners,
    };
}
